import { $api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export function useProjectMemory(projectId: string) {
  const { backendToken } = useAuth();
  return $api.useQuery(
    "get",
    "/api/v1/project-memory/{project_id}",
    { params: { path: { project_id: projectId } } },
    { staleTime: 5 * 60 * 1000, enabled: !!projectId && !!backendToken },
  );
}
